import { useState, memo } from 'react';
import { useSignal } from '@preact/signals-react';
import { CampaignChangesModal } from 'components';
import { ChartDayMetrics } from './ChartDayMetrics';
import { NotesIcon, InfoOutline } from 'assets/icons';

import * as S from './ChartDay.styled';

export const ChartDay = memo(
  ({
    day,
    dayData = {},
    tooltipPlacement,
    height,
    maxValues,
    metrics,
    colors,
    isDateShown,
    selectedMetricsSelector,
    withNotes,
    withModal,
    currentEventTitle,
  }) => {
    const [isHovered, setIsHovered] = useState(false);
    const isModalOpen$ = useSignal(false);

    return (
      <>
        <S.Container
          onClick={() => {
            if (withModal) isModalOpen$.value = true;
          }}
          onMouseOver={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className='day'
        >
          <S.Body style={{ height: `${height}px` }}>
            {isHovered && (
              <ChartDayMetrics
                day={day}
                dayData={dayData}
                metrics={metrics}
                colors={colors}
                height={height}
                tooltipPlacement={tooltipPlacement}
                maxValues={maxValues}
                selectedMetricsSelector={selectedMetricsSelector}
                currentEventTitle={currentEventTitle}
              />
            )}
          </S.Body>
          <S.DayWrapOuter
            style={{ opacity: isDateShown ? 1 : 0, marginBottom: withNotes ? '0' : '24px' }}
          >
            <S.DayWrapInner>
              <S.Day>{day.split(',').slice(-1).join('').replace(/^0/, '')}</S.Day>
            </S.DayWrapInner>
          </S.DayWrapOuter>
          {withNotes && (
            <S.IconsWrap>
              <S.InfoIconWrap>
                <InfoOutline />
              </S.InfoIconWrap>
              {dayData?.note && (
                <S.NotesIconWrap>
                  <NotesIcon />
                </S.NotesIconWrap>
              )}
            </S.IconsWrap>
          )}
        </S.Container>
        {withModal && isModalOpen$.value && (
          <CampaignChangesModal
            isOpen$={isModalOpen$}
            selectedDate={new Date(day)}
            data={dayData}
          />
        )}
      </>
    );
  },
);

ChartDay.displayName = 'ChartDay';
